var _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4, _rect5, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 21,
    viewBox: "0 0 108 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0 0.345703)",
    fill: "#19B361"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_4300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0011 14.5192L5.29875 17.1513L6.34897 11.8658L2.39258 8.20707L7.74394 7.57257L10.0011 2.6792L12.2581 7.57257L17.6095 8.20707L13.6531 11.8658L14.7033 17.1513L10.0011 14.5192Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(22 0.345703)",
    fill: "#19B361"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_63_4300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0011 14.5192L27.2988 17.1513L28.349 11.8658L24.3926 8.20707L29.7439 7.57257L32.0011 2.6792L34.2581 7.57257L39.6095 8.20707L35.6531 11.8658L36.7033 17.1513L32.0011 14.5192Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(44 0.345703)",
    fill: "#19B361"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_63_4300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0011 14.5192L49.2988 17.1513L50.349 11.8658L46.3926 8.20707L51.7439 7.57257L54.0011 2.6792L56.2581 7.57257L61.6095 8.20707L57.6531 11.8658L58.7033 17.1513L54.0011 14.5192Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(66 0.345703)",
    fill: "#19B361"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_63_4300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0011 14.5192L71.2988 17.1513L72.349 11.8658L68.3926 8.20707L73.7439 7.57257L76.0011 2.6792L78.2581 7.57257L83.6095 8.20707L79.6531 11.8658L80.7033 17.1513L76.0011 14.5192Z",
    fill: "white"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(88 0.345703)",
    fill: "#19B361"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_63_4300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0011 12.9912L100.832 14.5759L100.2 11.3937L102.582 9.1908L99.36 8.80876L98.0011 5.86255V12.9912ZM98.0011 14.5192L93.2988 17.1513L94.349 11.8658L90.3926 8.20707L95.7439 7.57257L98.0011 2.6792L100.258 7.57257L105.609 8.20707L101.653 11.8658L102.703 17.1513L98.0011 14.5192Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_4300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2.3457)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_63_4300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(24 2.3457)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_63_4300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(46 2.3457)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_63_4300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(68 2.3457)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_63_4300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(90 2.3457)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStars);
export default __webpack_public_path__ + "static/media/rating_stars.5d0687cf07b7b290321381b7e814ad05.svg";
export { ForwardRef as ReactComponent };